import styles from './styles.module.css'
import { COUNTRY_INFO } from '../../constans/countries/countries'
import { SearchBar } from '../../components/SearchBar/SearchBar'
import { useDataLoader } from '../../components/hooks/useDataLoader'
import { NavLink } from 'react-router-dom'
import { useState } from 'react'


export const AllCountriesFlagsPage = () => {

    const [markVisited, setMarkVisited] = useState(true);
    useDataLoader();
  
    return (
          <div className={styles.root}>
            <div className={styles.toggle_container}>
              <span className={styles.toggle_label}>
                {'Show visited'}
              </span>
              <div
                  className={`${styles.toggle} ${!markVisited ? styles.active : ''}`}
                  onClick={() => setMarkVisited(!markVisited)}>
                <div className={styles.toggle_button}>
                </div>
              </div>
            </div>
        <div className={styles.search_bar}>
          <SearchBar
            countries={COUNTRY_INFO}
            markVisited={markVisited}
          ></SearchBar>
          <footer className={styles.footer}>
            <div className={styles.footer_content}>
              <h1 className={styles.seo_text_h1}>Here is a collection of 250 world flags</h1>
              <h2 className={styles.seo_text}>
                This is probably all the flags of existing countries. Why "probably"? Because there are a lot of unrecognized or partially recognized countries that we didn't display here. Also, there are countries that have changed their name or flag and we haven't noticed yet — but we will.
                <br />The flags here are sorted alphabetically by country name, but you can also find any flag using the search bar by entering the ISO2 or ISO3 code (e.g., CV or CPV for Cape Verde), or a well-established abbreviation such as "USA" for the United States of America or "UAE" for the United Arab Emirates.
                By clicking on each flag, you can add the country to a wishlist or to a list of countries you have already visited — just click the "like" button or the "add" button. Then you can send a link to this list to your friends via messengers, or post it on X (formerly Twitter) or other social networks. 
                <br />There is also a page with the <NavLink className={styles.names_link} to={'/allnames'}>names</NavLink> of the same countries, featuring the same buttons and flag images.
              </h2>
            </div>
          </footer>
        </div>
      </div>
    )
}